import React from "react";
import { motion } from "framer-motion";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { waLink, telLink } from "@/lib/site-config";

const scrollToForm = () => {
  const el = document.getElementById("lead-form");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      className="relative py-24 md:py-36 border-t border-[#556340] overflow-hidden"
      data-testid="final-cta-section"
    >
      {/* Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] rounded-full bg-[#E8E5D0]/[0.08] blur-[120px]" />
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#E8E5D0] mb-5">
            Dein nächster Schritt
          </div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.9] text-balance">
            Dein Körper ist
            <br />
            <span className="lime-gradient-text">dein Fundament.</span>
          </h2>
          <p className="mt-7 text-[#C9C6B4] max-w-2xl mx-auto text-base sm:text-lg leading-relaxed">
            Mach den ersten Schritt. Schreib auf WhatsApp, ruf an, oder hinterlasse
            deine Daten – wir melden uns persönlich zurück.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <button
              onClick={scrollToForm}
              className="group inline-flex items-center gap-2 bg-[#E8E5D0] hover:bg-[#D6D3BF] text-[#3A4230] font-extrabold uppercase tracking-wider px-7 py-4 rounded-full transition-all"
              data-testid="final-cta-form-btn"
            >
              Kostenlose Analyse sichern
              <ArrowRight
                size={18}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold rounded-full px-6 py-4 transition-colors"
              data-testid="final-cta-whatsapp-btn"
            >
              <MessageCircle size={18} /> Auf WhatsApp schreiben
            </a>
            <a
              href={telLink()}
              className="inline-flex items-center gap-2 border border-[rgba(255,255,255,0.28)] hover:bg-black/[0.04] text-[#F3F1E8] font-bold rounded-full px-6 py-4 transition-colors"
              data-testid="final-cta-call-btn"
            >
              <Phone size={18} /> Direkt anrufen
            </a>
          </div>

          <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-[#8F8C7A]">
            Antwort innerhalb von 24 Stunden · DSGVO-konform · Unverbindlich
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
